import React from "react";
import {
  AdminTableHeader,
  AdminTableBody,
  AdminStatusBadge,
} from "../../../AdminDashboard/shared/adminUx";

const PaymentHistory = () => {
  const rows = [
    { id: "#TP2028601", date: "25 June 2025", amount: "$89.95", method: "VISA", status: "Paid" },
    { id: "#TP2028501", date: "25 May 2025", amount: "$49.95", method: "VISA", status: "Paid" },
    { id: "#TP2028401", date: "25 April 2025", amount: "$49.95", method: "VISA", status: "Paid" },
    { id: "#TP2028301", date: "25 March 2025", amount: "$49.95", method: "VISA", status: "Paid" },
  ];

  return (
    <>
      <div className="grid grid-cols-12 py-3 text-offblack border-b border-lightgray px-4">
        <div className="col-span-3 flex items-center">
          <AdminTableHeader>Invoice ID</AdminTableHeader>
        </div>
        <div className="col-span-3 flex items-center">
          <AdminTableHeader>Date</AdminTableHeader>
        </div>
        <div className="col-span-2 flex items-center justify-center">
          <AdminTableHeader>Amount</AdminTableHeader>
        </div>
        <div className="col-span-2 flex items-center justify-center">
          <AdminTableHeader>Method</AdminTableHeader>
        </div>
        <div className="col-span-2 flex items-center justify-center">
          <AdminTableHeader>Status</AdminTableHeader>
        </div>
      </div>

      {rows.map((r) => (
        <div
          key={r.id}
          className="grid grid-cols-12 py-3 px-4 text-offblack border-b border-lightgray last:border-b-0"
        >
          <div className="col-span-3 flex items-center">
            <AdminTableBody>{r.id}</AdminTableBody>
          </div>
          <div className="col-span-3 flex items-center">
            <AdminTableBody>{r.date}</AdminTableBody>
          </div>
          <div className="col-span-2 flex items-center justify-center">
            <AdminTableBody>{r.amount}</AdminTableBody>
          </div>
          <div className="col-span-2 flex items-center justify-center">
            <AdminTableBody>{r.method}</AdminTableBody>
          </div>
          <div className="col-span-2 flex items-center justify-center">
            <AdminStatusBadge status={r.status} label={r.status} />
          </div>
        </div>
      ))}
    </>
  );
};

export default PaymentHistory;
